import MixpanelTracker from '../mixpanelTracker';
import Action from '../Model/action';
import { ON_COPY_LINK } from '../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function onCopyOfEventLinkTracker(eventData) {
  const properties = {
    Action: Action.COPY,
    eventData,
  };
  mixpanelTracker.setEventName(ON_COPY_LINK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
